if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span') || this.submitButton.querySelector('p.t2');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || 1, 10) || 1;
        const productType = this.dataset.productType || '';
        const requiresShipping = this.dataset.requiresShipping !== 'false';

        // Оптимистичная batch-модель: товар идёт в pending CartStore (без сети).
        // Реальный запрос уйдёт ПАЧКОЙ при открытии drawer / checkout / уходе.
        if (window.CartStore && productVariantId) {
          window.CartStore.addItems([
            {
              id: parseInt(productVariantId, 10),
              quantity: quantity,
              product_type: productType,
              requires_shipping: requiresShipping,
            },
          ], { immediate: true });
        }

        const quickAddModal = this.closest('quick-add-modal');
        const quickAddProductId = quickAddModal?.id?.match(/^QuickAdd-(\d+)/)?.[1] || null;

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: productVariantId,
          productId: quickAddProductId,
          // displayCart для аналитики (cart-analytics использует token/total/items)
          cartData: window.CartStore ? window.CartStore.getCart() : undefined,
        });

        // Закрываем quick-add модалку (если есть) и открываем drawer —
        // он дофлашит pending и наполнится актуальной корзиной.
        if (quickAddModal) quickAddModal.hide(true);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.openAfterAdd === 'function') {
          cartDrawer.openAfterAdd(this.submitButton);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Сброс состояния кнопки (добавление оптимистичное — без ожидания сети).
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      /**
       * Проактивное добавление упаковки в тот же запрос при добавлении товара
       * Использует PackagingUtils для определения нужных упаковок
       */
      async checkAndAddAdditionalProduct() {
        // Упаковка — на checkout, не при добавлении в корзину.
      }
    }
  );
}
